import React from 'react'
import styles from './Experience.module.css'
import { HoverState } from '../../../assets/utils/cursorTypes';
import Box from './Boxes/Box';

export type ExperienceProps = {
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
}

const Experience = (props: ExperienceProps) => {
    return (
        <div className={styles.container}>
            <div className={styles.boxes}>
                <Box setHoverElement={props.setHoverElement} position='Software Developer' company='Samsys' timeline='2022-2023'  backgroundImage='samsys.png' website='https://samsys.pt/' />
                <Box setHoverElement={props.setHoverElement} position='Software Developer' company='Hard Creative Studio' timeline='2024-2025'  backgroundImage='hard_creative_studio.png' website='https://hardcreative.pt' />
                <Box setHoverElement={props.setHoverElement} position='Freelancer' company='Worldwide' timeline='2025-Present'  backgroundImage='worldwide.png' website='https://github.com/JorgeFMVieira' />
            </div>
        </div>
    )
}

export default Experience
